import { Loader2 } from 'lucide-react';

export default function SubmitButton({ isLoading }) {
  return (
    <button
      type="submit"
      disabled={isLoading}
      className="w-full py-3 px-4 mt-4 flex justify-center items-center rounded-xl bg-gradient-to-r from-[#1d57a5] to-[#29807b] hover:to-[#36a852] text-white font-medium transition-all shadow-lg shadow-[#1d57a5]/30 disabled:opacity-70 disabled:shadow-none"
    >
      {isLoading ? (
        <span className="flex items-center gap-2">
          <Loader2 size={20} className="animate-spin" /> Signing in...
        </span>
      ) : 'Sign In'}
    </button>
  );
}
